import { render } from "./PrintPublications.vue?vue&type=template&id=dbd58a3a&scoped=true"
import script from "./PrintPublications.vue?vue&type=script&lang=js"
export * from "./PrintPublications.vue?vue&type=script&lang=js"

import "./PrintPublications.vue?vue&type=style&index=0&id=dbd58a3a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dbd58a3a"]])

export default __exports__